import React from 'react';
import PropTypes from 'prop-types';
import toColorString from 'polished/lib/color/toColorString';

import color from '@decisiv/design-tokens/lib/color';
import InfoCircleF from '@decisiv/iconix/lib/components/InfoCircleF';
import Tooltip from '@decisiv/ui-components/lib/components/Tooltip';

import { InfoTipButton } from './styles';

/**
 * The (i) beside a column heading. A real button rather than a bare icon: KeyDS
 * Tooltip binds hover and focus to whatever node it is handed, so the target has
 * to be keyboard-reachable or the explanation is mouse-only.
 */
function InfoTip({ children, label }) {
  return (
    <Tooltip
      placement="top"
      target={
        <InfoTipButton aria-label={label} type="button">
          <InfoCircleF
            color={toColorString(color.status.information.medium)}
            size="small"
          />
        </InfoTipButton>
      }
    >
      {children}
    </Tooltip>
  );
}

InfoTip.propTypes = {
  /** The tooltip text. */
  children: PropTypes.string.isRequired,
  /** Accessible name for the trigger, since the icon carries no text. */
  label: PropTypes.string.isRequired,
};

export default InfoTip;
